export enum TeamLifecyclePeriodTaskAssignee {
	TeamOwner,
	Archivist
}